/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'

import {union_city_war_groups, union_city_war_homepage} from './service'
import type {UnionCityWarGroupsData, UnionCityWarHomepageData} from './types'

export const getHomepage = createAsyncThunk(
  'UnionCityWar/getHomepage',
  async (params: Record<string, unknown> = {}) => {
    return union_city_war_homepage(params)
  }
)

export const getGroups = createAsyncThunk(
  'UnionCityWar/getGroups',
  async (params: {stage: number}) => {
    return union_city_war_groups(params)
  }
)

interface UnionCityWarState {
  homepage: UnionCityWarHomepageData | null
  groups: UnionCityWarGroupsData | null
}

const initialState: UnionCityWarState = {
  homepage: null,
  groups: null,
}

export const UnionCityWarSlice = createSlice({
  name: 'UnionCityWar',
  initialState,
  reducers: {
    /** dev 预览：注入指定 homepage Mock */
    setHomepage: (state, action: PayloadAction<UnionCityWarHomepageData>) => {
      state.homepage = action.payload
    },
    /** dev 预览：注入指定 groups Mock */
    setGroups: (state, action: PayloadAction<UnionCityWarGroupsData>) => {
      state.groups = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomepage.fulfilled, (state, action) => {
        state.homepage = action.payload
      })
      .addCase(getGroups.fulfilled, (state, action) => {
        state.groups = action.payload
      })
  },
})

export default UnionCityWarSlice.reducer

export const UnionCityWarSliceActions = UnionCityWarSlice.actions

export const useReducerState = () => {
  return useSelector((state: {UnionCityWar: UnionCityWarState}) => {
    return state.UnionCityWar
  })
}
